import { render } from "./Card_Ads.vue?vue&type=template&id=7a58f8f0&scoped=true"
import script from "./Card_Ads.vue?vue&type=script&lang=js"
export * from "./Card_Ads.vue?vue&type=script&lang=js"

import "./Card_Ads.vue?vue&type=style&index=0&id=7a58f8f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a58f8f0"]])

export default __exports__